import { render, staticRenderFns } from "./DiseasesPieChart.vue?vue&type=template&id=108bce0f"
import script from "./DiseasesPieChart.vue?vue&type=script&lang=js"
export * from "./DiseasesPieChart.vue?vue&type=script&lang=js"
import style0 from "./DiseasesPieChart.vue?vue&type=style&index=0&id=108bce0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports